module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-card', {
    attrs: {
      "tile": ""
    }
  }, [_c('v-card-title', [_c('h3', [_vm._v("Readjustment")])]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-container', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "disabled": !_vm.$can('edit', 'case-readjustment'),
      "rules": _vm.readjustmentRules,
      "label": "Amount",
      "prefix": "$"
    },
    model: {
      value: (_vm.readjustment),
      callback: function($$v) {
        _vm.readjustment = $$v
      },
      expression: "readjustment"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "description"
  }, [_vm._v("\n            No spaces allowed. Only \"-\", \".\", \"0-9\". Correct values examples: \"-10.99\", \"23.35\", \"16\"\n          ")])])], 1)], 1)], 1), _vm._v(" "), _c('v-card', {
    attrs: {
      "tile": ""
    }
  }, [_c('v-card-title', [_c('h3', [_vm._v("New Tax Invoice Total after GST")])]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-container', [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-space-between": "",
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md8": ""
    }
  }, [_c('v-text-field', {
    staticClass: "disabled-active",
    attrs: {
      "disabled": true,
      "value": _vm.leftToPay,
      "label": "Amount",
      "prefix": "$"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md4": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "primary",
      "disabled": !_vm.$can('edit', 'case-readjustment'),
      "flat": "",
      "loading": _vm.loading
    },
    on: {
      "click": _vm.changeDeposit
    }
  }, [_vm._v("Save and send new tax invoice")])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-937a0138","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CaseReadjustment.vue
// module id = 1015
// module chunks = 1